/* 列傳選單點一章時的「圖解」：交戰雙方、前情、結果與影響（只寫正史；裴注要標出處，演義不放）
 * 鍵是列傳選單上的章節 id（分幕的章寫第一幕）。格式見 src/campaign/bg/index.ts。 */
// @ts-nocheck
export default {
  'taishici-1': {
    sides: [
      { f: 'han', n: '東萊郡', l: '太史慈（奏曹史）', w: 1 },
      { f: 'han', n: '青州', l: '州吏' },
    ],
    before: '東萊郡和青州起了爭執，朝廷還沒判斷誰對，誰的奏章先送到就佔上風。州的奏章已經先出發，郡守怕趕不上，挑了二十一歲的太史慈去洛陽。（年份由他四十一歲死於建安十一年推算，約在 186 年。）',
    after: '太史慈毀了州章、通了郡章，有司因為州章出了問題不再受理，州這邊吃了虧。太史慈從此出名，但也被州裡記恨，只好避到遼東。',
    src: '《三國志·吳書·太史慈傳》',
  },
  'taishici-2': {
    sides: [
      { f: 'wu', n: '孫策', l: '孫策', w: 1 },
      { f: 'han', n: '太史慈（自稱丹楊太守）', l: '太史慈、山越' },
    ],
    before: '太史慈從遼東回來，先為孔融突圍求救，後來渡江投靠劉繇，在神亭和孫策交過手。劉繇兵敗逃往豫章，太史慈沒跟去，逃進山裡自稱丹楊太守。當時孫策已平定宣城以東，只剩涇縣以西六縣不服，太史慈在涇縣立屯府，很多山越來依附。',
    after: '孫策親自來攻，太史慈被擒。孫策替他解開綁繩，問他神亭那天要是抓到自己會怎樣，太史慈答「未可量也」，孫策大笑重用他，拜折衝中郎將。後來孫策派他去收撫劉繇的殘部，他約定六十日內回來，果然如期而返。',
    src: '《三國志·吳書·太史慈傳》',
  },
  'taishici-3': {
    sides: [
      { f: 'wu', n: '孫策', l: '孫策、太史慈', w: 1 },
      { f: 'hj', n: '麻保賊', l: '麻保賊' },
    ],
    before: '太史慈歸附後，孫策常和他商議軍事。孫策出兵討伐據屯自守的麻保賊（正史沒寫年份，只知道在孫策生前），賊人在屯裡的樓上一邊走一邊叫罵。',
    after: '那個賊伸手扶住樓上的橫梁，太史慈一箭射穿他的手，把手釘在梁上，屯外上萬人都叫好。正史拿這件事說明太史慈「猿臂善射，弦不虛發」。',
    src: '《三國志·吳書·太史慈傳》',
  },
  'taishici-4': {
    sides: [
      { f: 'wu', n: '孫策、孫權', l: '太史慈（建昌都尉）', w: 1 },
      { f: 'lbiao', n: '劉表', l: '劉磐' },
    ],
    before: '劉表的姪子劉磐很勇猛，屢次來寇掠艾、西安等縣（他當時和黃忠一起守長沙攸縣）。孫策把海昏、建昌一帶六縣劃出來，任太史慈為建昌都尉，治所設在海昏，督率諸將抵禦劉磐。',
    after: '劉磐從此不敢再來。孫權接掌江東後，因為太史慈能制住劉磐，把南方的事都交給他。太史慈建安十一年（206）去世，年四十一；裴注引《吳書》記他臨終歎「丈夫生世，當帶七尺之劍，以升天子之階」。',
    src: '《三國志·吳書·太史慈傳》；〈黃忠傳〉；裴注引《吳書》',
  },
};
